import { Briefcase, Clock, DollarSign, TrendingUp } from 'lucide-react';

import type { OpportunityStatsResponse } from '@/types/service/internalAnalytics';

import { Card, CardContent } from '@/components/ui/card';

import { formatCurrency, formatNumber } from '@/utils/saasDashboardHelpers';

interface OpportunityStatsCardsProps {
  data: OpportunityStatsResponse;
}

const OpportunityStatsCards = ({ data }: OpportunityStatsCardsProps) => {
  const stats = [
    {
      label: 'Open Opportunities',
      value: formatNumber(data.open_opportunities),
      icon: Briefcase,
      color: 'text-blue-600',
      bgColor: 'bg-blue-50',
    },
    {
      label: 'New Opportunities (7 days)',
      value: formatNumber(data.new_opportunities),
      icon: TrendingUp,
      color: 'text-emerald-600',
      bgColor: 'bg-emerald-50',
    },
    {
      label: 'Closing Opportunities (7 days)',
      value: formatNumber(data.closing_opportunities),
      icon: Clock,
      color: 'text-amber-600',
      bgColor: 'bg-amber-50',
    },
    {
      label: 'Total Amount',
      value: formatCurrency(data.total_amount),
      icon: DollarSign,
      color: 'text-green-600',
      bgColor: 'bg-green-50',
    },
  ];

  return (
    <div className='grid grid-cols-2 md:grid-cols-4 gap-4'>
      {stats.map((stat) => {
        const Icon = stat.icon;
        return (
          <Card key={stat.label}>
            <CardContent className='p-4'>
              <div className='flex items-center gap-3'>
                <div className={`p-2 rounded-lg ${stat.bgColor}`}>
                  <Icon className={`h-5 w-5 ${stat.color}`} />
                </div>
                <div>
                  <p className='text-2xl font-bold'>{stat.value}</p>
                  <p className='text-sm text-muted-foreground'>{stat.label}</p>
                </div>
              </div>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
};

export default OpportunityStatsCards;
